import { api } from "@/lib/api/client";
import type { operations } from "@/lib/api/generated/api";

type ServerStatusBody =
  operations["ServerStatusController_get"]["responses"][200]["content"]["application/json"];

/**
 * Sunucunun o anki hâli — tek bir okumada, tek bir ana ait (`measuredAt`).
 *
 * TİP ÜRETİLMİŞ BELGEDEN, elle yazılmadı. Ekran önceden kendi arayüzünü taşıyordu; sunucu bir
 * alanı yeniden adlandırsa derleme yine geçer, kutular sessizce «—» çizerdi.
 */
export type ServerStatus = ServerStatusBody["data"];

export const serverStatusApi = {
  /** `system.job.read` ile kapalı — «Sunucu» menü satırının kapısıyla aynı anahtar. */
  get: (): Promise<ServerStatus> => api.get<ServerStatus>("/system/server-status"),
};
